import { randomValue } from "@/lib/random";

export default {
	namespaced: true,
	getters: {
		randomHeadline: (state, getters, rootState, rootGetters) => {
			const rating = rootGetters["game/performance/rating"];
			const { headlines } = rootState.global.api.data["performance-reviews"];
			const { text } = randomValue(headlines[rating]);

			return text;
		},
		randomReviewText: (state, getters, rootState, rootGetters) => {
			const rating = rootGetters["game/performance/rating"];
			const { reviews } = rootState.global.api.data["performance-reviews"];
			const { text } = randomValue(reviews[rating]);

			return text;
		},
		randomReviewer: (state, getters, rootState) => {
			const { reviewers } = rootState.global.api.data["performance-reviews"];
			const { name } = randomValue(reviewers);
			return name;
		},
		meterReportText: (state, getters, rootState, rootGetters) => {
			const meterReports = rootGetters["game/scores/ordered"].map((score) => {
				const change = rootGetters[`game/scores/${score.id}/change`];
				const meterReport = rootState.global.api.data["performance-reviews"].meter_report;
				const { text } = randomValue(meterReport[change][score.id]);
				return { ...score, change, report: text };
			});

			return meterReports;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/reviews.store.js